import { useEffect, useState } from "react";

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function usePwaInstall() {
  const [canPrompt, setCanPrompt] = useState(!!window.__azvInstallPrompt);
  const [installed, setInstalled] = useState(isStandalone());
  useEffect(() => {
    const ready = () => setCanPrompt(true);
    const done = () => {
      setInstalled(true);
      setCanPrompt(false);
    };
    window.addEventListener("azv-install-ready", ready);
    window.addEventListener("appinstalled", done);
    return () => {
      window.removeEventListener("azv-install-ready", ready);
      window.removeEventListener("appinstalled", done);
    };
  }, []);
  const prompt = async () => {
    const p = window.__azvInstallPrompt;
    if (!p) return false;
    p.prompt();
    const { outcome } = await p.userChoice;
    window.__azvInstallPrompt = null;
    setCanPrompt(false);
    return outcome === "accepted";
  };
  return { canPrompt, installed, prompt, ios: isIOS() };
}
